import { request } from '@/utils/request'

export function getProjectDetail (id) {
  return request.get(`/project/${id}`)
}

export function getExhibitionList (query) {
  const {
    pageNum,
    pageSize,
    ...params
  } = query
  return request.post(`/project/index/${pageNum}/${pageSize}`, params)
}

export function getExhibitionSearch (params) {
  return request.get('/exhibition/search', {
    params,
  })
}

export function getExhibitionDetail (id) {
  return request.get(`/exhibition/details/${id}`)
}

export function getPreviewDetail (id) {
  return request.get(`/exhibition/previewDetail?previewId=${id}`)
}
